import { cn } from '@crm/shared/lib';

import { getColorDotProps } from '../../lib';

export const ColorDot = ({ color, className }: { color: string; className?: string }) => {
    const colorDotProps = getColorDotProps(color);

    return <span {...colorDotProps} className={cn(colorDotProps.className, className)} />;
};
